import { apiFetch } from './client';

export const fetchHealth = () => apiFetch<{ status?: string; success?: boolean }>(`/health`, { auth: false });

export const fetchOpenApiSpec = () => apiFetch<unknown>(`/api/v1/openapi.json`, { auth: false });

